module.exports = __webpack_public_path__ + "img/affiliate-pana-min.52e6ab96.png";